import React from 'react'
import PaymentReconciliation from '../../features/PaymentReconciliation/PaymentReconciliation'
import ViewResourcesForm from '../../features/Resources/ViewResourcesForm'

const ViewResources = () => {
  return (
    <div>
      <ViewResourcesForm />
    </div>
  )
}

export default ViewResources
